import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";



function Gallery() {
    const [photos, setPhotos] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("/gallery.json")
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                console.log("Gallery data loaded:", data)
                setPhotos(data)
            })
            .catch((err) => {
                console.error("Error loading gallery:", err);
                setError(err.message);
            });
    }, []);

    if (error) return <div>Error loading gallery: {error}</div>;
    if (!Array.isArray(photos)) return <div>Gallery data is invalid</div>;
    if (!photos.length) return <div>Loading gallery...</div>;


    return <ImageGallery items={photos} />;
}

export default Gallery;
